import view from './view'

export default {
    view,
    title: 'Work spaces',
    new: 'New',
    pageTitle: 'WORK SPACES - OVERVIEW',
    empty: {
        title: 'Looking for content?',
        content: 'Create a work space.',
        action: 'Create work space'
    }
}
